export default __webpack_public_path__ + "static/unionBank-1a26ec70941e7f579c38279266fe1fef.svg";